import BybMedalElement from "@Components/common/byb-ds/byb-medal-element";
import { useCareerContext } from "@Context/game/career/career-context";
import Leagues from "@Enums/Leagues";
import { getLeagueColor } from "@Helpers/league-utils";
import { Box, useTheme } from "@mui/material";
import { RadialBar, RadialBarChart, ResponsiveContainer } from "recharts";

const CareerProgressChart = () => {
  const theme = useTheme();
  const { league, remainingDivisions } = useCareerContext();

  if (!league?.divisions) return null;

  const chartData = [
    {
      name: "score",
      score: league.divisions.length - remainingDivisions,
      maxScore: league.divisions.length,
    },
  ];

  return (
    <Box position="relative" width="100%" height="100%">
      <Box position="absolute" top="46%" left="50%" sx={{ transform: "translate(-50%, -50%)", zIndex: 1 }}>
        <BybMedalElement league={league.name as Leagues} size={16} />
      </Box>
      <ResponsiveContainer>
        <RadialBarChart
          innerRadius="90%"
          outerRadius="115%"
          margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
          data={chartData}
          startAngle={-270}
          endAngle={-630}
        >
          <RadialBar dataKey="maxScore" maxBarSize={0} fill="transparent" />
          <RadialBar
            dataKey="score"
            cornerRadius={8}
            fill={getLeagueColor(league.name as Leagues, theme)}
            background={{ fill: theme.palette.dsSurface.v400 }}
          />
        </RadialBarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default CareerProgressChart;
